<div class="container single-view" id="manage-market-retailers">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a [routerLink]="['/markets', marketId]" class="inline-flex items-center text-base link link-icon left-arrow">
          {{ 'MANAGE_MARKET_RETAILERS.BTN_BACK_TO_MARKET' | translate }}
        </a>
      </div>
    </div>

    <div class="col-12">
      <div id="view-header-wr"
        class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 class="section-title">{{ 'MANAGE_MARKET_RETAILERS.TITLE' | translate }}</h1>
          <p class="section-subtitle mt-1 text-base">{{ 'MANAGE_MARKET_RETAILERS.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>

      <hr role="presentation" class="w-full mb-2 mt-6 border-t">

      <div class="view-content-wr">
        <!-- main content -->
        @if (market && !isLoadingMarket) {
          <form [formGroup]="manageMarketRetailersFormGroup"
            (ngSubmit)="submitForm()">
            <div class="row">
              <div class="flex flex-col col-12 text-wr mb-1">
                <h2>{{ 'MANAGE_MARKET_RETAILERS.SEARCH_RETAILERS' | translate }}</h2>
              </div>

              <div class="field-wr flex flex-col col-12">
                <label class="block text-sm mb-4" for="retailers">
                  {{ 'MANAGE_MARKET_RETAILERS.SEARCH_BY_NAME' | translate }}
                </label>

                <app-custom-dropdown
                  id="retailers"
                  data-testid="retailers"
                  [placeholder]="'MANAGE_MARKET_RETAILERS.SELECT_RETAILERS_PLACEHOLDER' | translate"
                  [fieldLabel]="'MANAGE_MARKET_RETAILERS.SELECT_RETAILERS_PLACEHOLDER' | translate"
                  [options]="retailersList"
                  optionLabel="text"
                  optionValue="id"
                  [isMultiselect]="true"
                  [showSelectionChips]="false"
                  [showClear]="true"
                  [compactUi]="false"
                  [searchMode]="'remote'"
                  [pageSize]="retailersRowsPerPageOption"
                  [totalCount]="retailersTotalRecords"
                  [totalPages]="getRetailersTotalPages()"
                  formControlName="retailers"
                  (onLazyLoad)="onLazyLoadRetailers($event)">
                </app-custom-dropdown>
              </div>

              @if (assignedRetailers.length > 0) {
                <div class="row">
                  <div class="flex flex-col col-12 text-wr">
                    <p class="label text-sm">{{ 'MANAGE_MARKET_RETAILERS.ASSIGNED_RETAILERS' | translate }}:</p>
                    <div class="chips-wr">
                      @for (retailer of assignedRetailers; track retailer.id) {
                        <div class="chip-item">
                          <p-chip>
                            {{ retailer.text }}
                          </p-chip>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }

              @if (getSelectedRetailers().length > 0) {
                <div class="flex flex-col col-12 text-wr">
                  <p class="label text-sm">{{ 'MANAGE_MARKET_RETAILERS.RETAILERS_TO_BE_ADDED' | translate }}:</p>
                  <div class="chips-wr">
                    @for (retailer of getSelectedRetailers(); track retailer.id) {
                      <div class="chip-item">
                        <p-chip>
                          {{ retailer.text }}
                        </p-chip>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>

            <div class="row">
              <div class="col-12 mt-6 mb-4 pt-8 border-t">
                <div class="flex items-center justify-end gap-3">
                  <button type="submit"
                    id="btn-manage-retailers"
                    class="btn primary-btn"
                    pButton
                    [disabled]="manageMarketRetailersFormGroup.invalid ||  getSelectedRetailers().length === 0 || isSaving">
                    {{ 'MANAGE_MARKET_RETAILERS.BTN_ADD_RETAILERS' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        }
        <!-- /main content -->
      </div>
    </div>
  </div>
</div>
